  <div>
    <div class="floating-cart" [style.--fc-bottom]="bottomInsetCss" [style.--fc-safe]="safeAreaMultiplier"
      (click)="viewCart()" *ngIf="shouldShow">
      <div class="cart-content">
        <span class="badge">
          <span class="badge-ring" *ngIf="isSyncingCart" aria-hidden="true"></span>
          <ng-container *ngIf="!isSyncingCart">{{badgeCount}}</ng-container>
        </span>
          {{ labelKey | translate }}
      </div>
      <!-- Only a live cart has a total. A previous order's money is already settled, and
           showing the cart's (zero) total next to "View previous order" would read as a
           free order. -->
      <!-- Dimmed while an edit is on its way: the figure is from before it. -->
      <div *ngIf="showsTotal" [class.cart-total-stale]="isSyncingCart">
        {{cartTotal | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
        <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(cartTotal)">  {{getSecondPrice(cartTotal)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
      </div>
    </div>
  </div>
